/**
 * Closed GRMS channel-role vocabulary.
 *
 * Keep this list synchronized with BMS-spec/docs/grms/specification.md §10.3.
 */
export const GRMS_ROLES = [
    'dnd',
    'mur',
    'presence',
    'lockbell',
    'minibar',
    'hvac_temp_zone1',
    'hvac_temp_zone2',
    'window_contact',
    'emergency',
    'alarm_zone',
    'energy_meter',
];
export function isGrmsRole(value) {
    return typeof value === 'string' && GRMS_ROLES.includes(value);
}
//# sourceMappingURL=grmsRoles.js.map